<script setup>
import { useAnalysisStore } from '@/store/modules/analysis';
import { addContentLogAPI } from '@/api/logServiceApi';

const analysisStore = useAnalysisStore();

/** 사주풀이 이용하기 버튼 */
const clickGoSummaryButton = () => {
  // 시작하기 발화 (사주풀이는 무료 전용이라 free). 신규 type — DB 등록 후 작동
  addContentLogAPI({
    contentType: 'as_summary_btn_start_free',
  });
  analysisStore.navigateToContent('/summary', 0);
};
</script>
<template>
  <div class="summary-desc overview_guide_area_desc">
    <div class="summary-desc__top">
      <div class="desc-top__tit">
        <div class="desc-top__tit-txt">
          사주 조회는 했는데 <br />
          일간, 십성, 십이운성, 대운... <br />
          도무지 무슨 말인지 모르겠어요...
        </div>
        <div class="desc-top__tit-img"></div>
      </div>
      <div class="desc-top__cont">
        <div class="desc-top__txt">
          사주 결과를 처음 접하면 낯선 용어들과 복잡한 <br />
          구조에 당황스러운 마음이 드는 건 자연스러워요. <br />
          무슨 뜻인지 몰라서, 그냥 화면을 닫아버렸던 마음은 <br />
          결코 당신만의 경험은 아니예요.
        </div>
        <div class="desc-top__txt">
          하지만 그 생소한 단어들 속에는 <b>‘나는 어떤 사람인지’</b><br />
          <b>‘지금 어떤 흐름 위에 서 있는지’</b> 를 <br />
          들여다 볼 수 있는 중요한 해석이 담겨 있어요!
        </div>
        <div class="desc-top__txt">
          그래서 낭만만세력은 전문 용어를 가능한 쉽게 풀고, <br />
          사주를 일상의 언어로 함께 해석해 가고자 해요.
        </div>
      </div>
    </div>
    <div class="summary-desc__bottom">
      <button class="desc-btn overview_guide_button_start" @click="clickGoSummaryButton">
        사주풀이 이용하기
      </button>
    </div>
  </div>
</template>
